const Message = () => {
  return <>Message Page</>;
};
export default Message;
